let VUE_APP_BASE_API_URL = {
  local: 'https://api.fat.tinman.cn',
  dev: 'https://api.dev.tinman.cn',
  fat: 'https://api.fat.tinman.cn',
  uat: 'https://api.uat.tinman.cn',
  pro: 'https://api.tinman.cn'
}

let VUE_APP_BASE_API_AUTH_URL = {
  local: 'https://jojosz-auth.fat.tinman.cn/',
  dev: 'https://jojosz-auth.dev.tinman.cn/',
  fat: 'https://jojosz-auth.fat.tinman.cn/',
  uat: 'https://jojosz-auth.uat.tinman.cn/',
  pro: 'https://jojosz-auth.tinman.cn/'
}

let VUE_APP_WX_APPID = {
  dev: 'wx43c3092d9a008aac',
  uat: 'wx2ca82573fd2406f1',
  fat: 'wx43c3092d9a008aac',
  pro: 'wx1082863b2a1afb9c'
}

let VUE_APP_PAGE_URL = {
  local: 'https://jojosz.dev.tinman.cn',
  dev: 'https://jojosz.dev.tinman.cn',
  fat: 'https://jojosz.fat.tinman.cn',
  uat: 'https://jojosz.uat.tinman.cn',
  pro: 'https://jojosz.tinman.cn'
}

let VUE_APP_JOJOREAD_PAGE_URL = {
  local: 'https://jojoread.tinman.cn',
  dev: 'https://jojoread.dev.tinman.cn',
  fat: 'https://jojoread.fat.tinman.cn',
  uat: 'https://jojoread.uat.tinman.cn',
  pro: 'https://jojoread.tinman.cn'
}

let VUE_APP_PUT_PLATFORM_API_URL = {
  dev: 'https://vulcan.dev.tinman.cn',
  fat: 'https://vulcan.fat.tinman.cn',
  uat: 'https://vulcan.uat.tinman.cn',
  pro: 'https://vulcan.tinman.cn'
}

let VUE_APP_JOJOREAD_API = {
  dev: 'https://api.dev.jojoread.com',
  fat: 'https://api.fat.jojoread.com',
  uat: 'https://api.uat.jojoread.com',
  pro: 'https://api.jojoread.com'
}

const runtimeEnv = window.process.env
const env = runtimeEnv.VUE_APP_ENV

const config = {
  env: env,
  pkgVersion: runtimeEnv.VUE_APP_WEB_VERSION,
  buildTime: runtimeEnv.VUE_APP_BUILD_DATE,
  baseApiUrl: runtimeEnv.VUE_APP_BASE_API_URL || VUE_APP_BASE_API_URL[env],
  baseAuthApiUrl: runtimeEnv.VUE_APP_BASE_API_AUTH_URL || VUE_APP_BASE_API_AUTH_URL[env],
  // wx 微信app id
  appId: runtimeEnv.VUE_APP_WX_APPID || VUE_APP_WX_APPID[env],
  PAGE_URL: runtimeEnv.VUE_APP_PAGE_URL || VUE_APP_PAGE_URL[env],
  JOJOREAD_PAGE_URL: runtimeEnv.VUE_APP_JOJOREAD_PAGE_URL || VUE_APP_JOJOREAD_PAGE_URL[env],
  PUT_PLATFORM_API_URL:
    runtimeEnv.VUE_APP_PUT_PLATFORM_API_URL || VUE_APP_PUT_PLATFORM_API_URL[env],
  JOJOREAD_API: runtimeEnv.VUE_APP_JOJOREAD_API || VUE_APP_JOJOREAD_API[env],
  SENSORS_URL: runtimeEnv.VUE_APP_SENSORS_URL,
  APP_NAME: runtimeEnv.VUE_APP_APP_NAME || undefined
}
export default config
